import type { GameState } from '../types';

// ============================================
// HUD - Interfaz de usuario del juego
// ============================================

export class HUD {
  private container: HTMLElement;
  private interactionPrompt: HTMLElement | null = null;
  private crosshair: HTMLElement | null = null;
  private infoPanel: HTMLElement | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  init(): void {
    this.createCrosshair();
    this.createInteractionPrompt();
    this.createInfoPanel();
    console.log('[HUD] Inicializado');
  }

  private createCrosshair(): void {
    this.crosshair = document.createElement('div');
    this.crosshair.id = 'crosshair';
    this.crosshair.innerHTML = `
      <div class="crosshair-dot"></div>
    `;
    this.container.appendChild(this.crosshair);
  }

  private createInteractionPrompt(): void {
    this.interactionPrompt = document.createElement('div');
    this.interactionPrompt.id = 'interaction-prompt';
    this.interactionPrompt.className = 'hidden';
    this.interactionPrompt.innerHTML = `
      <span class="key">E</span>
      <span class="label"></span>
    `;
    this.container.appendChild(this.interactionPrompt);
  }

  private createInfoPanel(): void {
    this.infoPanel = document.createElement('div');
    this.infoPanel.id = 'info-panel';
    this.infoPanel.innerHTML = `
      <div class="frequency-display">
        <span class="label">FRECUENCIA</span>
        <span class="value">--.- MHz</span>
      </div>
    `;
    this.container.appendChild(this.infoPanel);
  }

  showInteractionPrompt(label: string): void {
    if (!this.interactionPrompt) return;
    this.interactionPrompt.querySelector('.label')!.textContent = label;
    this.interactionPrompt.classList.remove('hidden');
  }

  hideInteractionPrompt(): void {
    if (!this.interactionPrompt) return;
    this.interactionPrompt.classList.add('hidden');
  }

  updateFrequency(frequency: number): void {
    if (!this.infoPanel) return;
    const valueEl = this.infoPanel.querySelector('.value');
    if (valueEl) {
      valueEl.textContent = `${frequency.toFixed(1)} MHz`;
    }
  }

  update(_state: GameState): void {
    // Actualizaciones futuras: salud, inventario, etc.
  }

  dispose(): void {
    this.crosshair?.remove();
    this.interactionPrompt?.remove();
    this.infoPanel?.remove();
  }
}
